// libs
import { useState } from "react";
import { useNavigate } from "react-router-dom";

// components
import CustomInput from "../../components/CustomInput";
import CustomButton from "../../components/CustomButton";

// custom hooks
import useToken from "../../hooks/useToken.jsx";
import useAlert from "../../hooks/useAlert";

// config
import API from "../../utils/api.js";

// constants
import ROUTES from "../../constants/routes";

// styles
import classes from "./styles.module.css";

export default function AuthPage() {
  const [tabInd, setTabInd] = useState(0);
  const [username, setUsername] = useState("");
  const [pass, setPass] = useState("");
  const [, updateToken] = useToken();
  const { createAlert } = useAlert();

  const navigate = useNavigate();

  const onLogin = () => {
    const usernameTrimed = username.trim();
    const passTrimed = pass.trim();

    if (usernameTrimed && passTrimed) {
      API.post("/auth/login", {
        username: usernameTrimed,
        pass: passTrimed,
      }).then((d) => {
        const data = d.data;

        if (data?.token) {
          updateToken(data.token);
          navigate(ROUTES.HOME);
        } else {
          createAlert.error(data.message ?? "Неверный логин или пароль");
        }
      });
    }
  };

  const onRegister = () => {
    const usernameTrimed = username.trim();
    const passTrimed = pass.trim();

    if (usernameTrimed && passTrimed) {
      API.post("/auth/register", {
        username: usernameTrimed,
        pass: passTrimed,
      }).then((d) => {
        if (d?.status === 200) {
          navigate(ROUTES.AUTH_LOGIN);
          createAlert.success("Вы зарегистрировались. Выполните вход");
          setUsername("");
          setPass("");
        } else {
          createAlert.error(d?.data?.message ?? "Ошибка регистрации");
        }
      });
    }
  };

  const isLogin = tabInd === 0;

  return (
    <div className={classes.root}>
      <div className={classes.box}>
        <div className={classes.header}>
          <CustomButton
            onClick={() => setTabInd(0)}
            className={`${classes.tabButton} ${tabInd === 0 && classes.tabButtonActive}`}
          >
            <span>Вход</span>
          </CustomButton>

          <CustomButton
            onClick={() => setTabInd(1)}
            className={`${classes.tabButton} ${tabInd === 1 && classes.tabButtonActive}`}
          >
            <span>Регистрация</span>
          </CustomButton>
        </div>

        <div className={classes.inputs}>
          <CustomInput
            placeholder="Имя пользователя"
            value={username}
            setValue={setUsername}
            className={classes.input}
          />

          <CustomInput
            placeholder="Пароль"
            value={pass}
            setValue={setPass}
            className={classes.input}
          />

          <CustomButton
            text={isLogin ? "Авторизоваться" : "Зарегестрировать аккаунт"}
            onClick={isLogin ? onLogin : onRegister}
            className={classes.submitButton}
          />
        </div>
      </div>
    </div>
  );
}
